import { Component } from '@verndale/core';
import { debounce } from '../../helpers/index';


class ContentCard extends Component {
  setupDefaults() {
    this.dom = {
      contentContainer: this.el.querySelector('.bicentennial-content-card__copy'),
      content: this.el.querySelector('.bicentennial-content-card__copy-content'),
      link: this.el.querySelector('.bicentennial-content-card__link')
    };

    this.originalContent = this.dom.content.innerText;

    this.addEllipsis();
  }

  addListeners() {
    window.addEventListener('resize', debounce(this.handleResize.bind(this), 200));
  }

  resetContent() {
    this.dom.content.innerText = this.originalContent;
  }

  addEllipsis() {
    const containerHeight = this.dom.contentContainer.getBoundingClientRect().height;
    if (containerHeight >= 124) {
      while (this.dom.content.clientHeight > containerHeight) {
        this.dom.content.innerText = this.dom.content.innerText.replace(/\W*\s(\S)*$/, '...');
      }
    }

    if (this.dom.link) {
      this.dom.content.appendChild(this.dom.link);
    }
  }

  handleResize() {
    this.resetContent();
    this.addEllipsis();
  }
}

export default ContentCard;
